export function makeImageUrl(imagePath: string): string {
    return '/assets/images/' + imagePath;
}
